import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import moment from "moment/moment";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import MySegmented from "../../components/segmented/Segmented.jsx";
import columns from "../../columns/reports/paymentsReport.js";
import {
  GetPaymentReportApi,
  ApprovePaymentApi,
} from "../../api/request/report.js";
import SkeletonTable from "../../components/table/SkeletonTable.jsx";

const PaymentsReport = () => {
  const { state } = useLocation();
  const [segmentedValue, setSegmentedValue] = useState(state?.type || "card");
  const [paymentList, setPaymentList] = useState([]);
  const [total, setTotal] = useState(0);
  const [count, setCount] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);

  const paymentType = [
    { label: `Card (${count?.card_count || 0})`, value: "card" },
    { label: `Interac (${count?.interac_count || 0})`, value: "interac" },
  ];

  const getPaymentList = async (page = 1) => {
    try {
      setIsLoading(true);
      const params = { page, type: segmentedValue };
      const { data } = await GetPaymentReportApi(params);
      if (data?.status) {
        setPaymentList(
          data?.data?.map((item) => {
            return {
              ...item,
              name: item?.user?.name,
              email: item?.user?.email,
              file_number: item?.files?.file_number,
              file: (
                <div className="font-bold highlight-text capitalize">
                  {item?.files?.service_name_slug}
                </div>
              ),
              startDate: item?.created_at
                ? moment(item?.created_at).format("lll")
                : "",
              statusValue: item?.status.toLowerCase(),
              status: (
                <>
                  {segmentedValue === "card" ? (
                    <p
                      className={`font-bold uppercase ${
                        item?.status === "paid"
                          ? "text-green-500"
                          : "text-red-500"
                      }`}
                    >
                      {item?.status}
                    </p>
                  ) : (
                    <>
                      {item?.status === "paid" ? (
                        <p className="font-bold uppercase text-green-500">
                          {item?.status}
                        </p>
                      ) : (
                        <button
                          className="bg-primary text-white font-medium uppercase px-4 py-2 rounded-lg"
                          onClick={() => approveHandler(item)}
                        >
                          Approve
                        </button>
                      )}
                    </>
                  )}
                </>
              ),
              action: (
                <a
                  href={item?.files?.invoice_pdf?.url || "#"}
                  target={item?.files?.invoice_pdf?.url && "_blank"}
                  className="font-medium text-blue-500 underline"
                >
                  View
                </a>
              ),
            };
          })
        );
        setTotal(data?.total_record);
        setCount(data?.count);
        setCurrentPage(page);
      }
      setIsLoading(false);
    } catch (error) {
      setPaymentList([]);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getPaymentList();
  }, [segmentedValue]);

  const handleTableChange = (pagination) => {
    getPaymentList(pagination?.current);
  };

  const spinner = (
    <div className="my-2">
      <Spin indicator={<LoadingOutlined />} />
    </div>
  );

  const setApproveData = (payment, status, isLoading) => {
    setPaymentList((prev) => {
      return prev.map((item) => {
        if (item?.id === payment?.id) {
          return {
            ...item,
            status: isLoading ? (
              spinner
            ) : (
              <>
                {status === "approved" ? (
                  <p className="text-green-500 font-bold uppercase">{status}</p>
                ) : (
                  <button
                    className="bg-primary text-white font-medium uppercase px-4 py-2 rounded-lg"
                    onClick={() => approveHandler(payment)}
                  >
                    Approve
                  </button>
                )}
              </>
            ),
          };
        }
        return item;
      });
    });
  };

  const approveHandler = async (payment) => {
    try {
      setApproveData(payment, "pending", true);
      const { data } = await ApprovePaymentApi({ file_id: payment?.file_id });
      if (data?.status) setApproveData(payment, "approved", false);
    } catch (error) {
      if (error?.response?.data?.message)
        toast.error(error?.response?.data?.message);
      setApproveData(payment, "pending", false);
    }
  };

  return (
    <div className="border rounded-xl bg-white">
      <div className="flex flex-col gap-4">
        <MySegmented
          options={paymentType}
          value={segmentedValue}
          setValue={setSegmentedValue}
        />

        <div className="table-radius-0 text-light mb-4">
          <SkeletonTable
            columns={columns}
            data={paymentList}
            isLoading={isLoading}
            searchingFields={["name", "email", "file_number"]}
            pagination={{
              current: currentPage,
              total: total,
              pageSize: 10,
              showSizeChanger: false,
            }}
            handleTableChange={handleTableChange}
          />
        </div>
      </div>
    </div>
  );
};

export default PaymentsReport;
